<template>
  <div class="position-relative">
    <div class="custom-skeleton" v-if="!isMapLoaded">
      <b-skeleton-img no-aspect/>
    </div>
    <img
      v-show="isMapLoaded"
      src="/map/v7.svg"
      alt="Карта"
      class="map-svg"
      @load="setMapLoaded"
    />
    <div class="map-container-description">
      <MapSchoolCard
        :type="contentType"
        :schools="selectedSchool"
        :link-prefix="link"/>
    </div>
    <div
      v-show="isMapLoaded"
      class="position-absolute"
      v-for="(school, index) of classes"
      :key="index"
      :style="{
        top: getOffset(school.pos[0], index, 10) + 'px',
        left: school.pos[1] + 'px'
      }"
    >
      <img
        :src="'/images/markers/' +
          contentType +
          (selectedIndex === index
            ? '_selected'
            : (hoverIndex === index ? '_primary' : '_default')) +
          '.svg'"
        class="map-marker-image"
        @click="changeSelectedStatus(index)"
        @mouseover="changeHoverStatus(index)"
        @mouseout="changeHoverStatus(index)"
      >
      <div class="map-marker-title"
           :style="{ marginLeft: school.offset[0] + 'px', marginTop: school.offset[1] + 'px'}"
      >
        {{ school.federalSubject }}
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import MapSchoolCard from '@/components/main-page/map/SchoolCard.vue'

export default {
  components: { MapSchoolCard },
  name: 'Map',
  data() {
    return {
      selectedIndex: null,
      hoverIndex: null,
      isMapLoaded: false,
      selectedSchool: {},
      classes: [],
      link: '/gazprom-classes/',
      contentType: null
    }
  },
  computed: {
    ...mapGetters({
      gpClasses: 'content/getGPClasses',
      gpUnivers: 'content/getAllPartners',
      gpFields: 'content/getGPFields'
    })
  },
  watch: {
    gpClasses: {
      deep: true,
      handler() {
        this.link = '/gazprom-classes/'
        this.contentType = 'classes'
        this.transformInfoClassesToMapStyle(this.gpClasses)
      }
    },
    gpUnivers: {
      deep: true,
      handler() {
        this.link = '/gazprom-universities/'
        this.contentType = 'univers'
        this.transformInfoClassesToMapStyle(this.gpUnivers)
      }
    },
    gpFields: {
      deep: true,
      handler() {
        this.link = ''
        this.contentType = 'fields'
        this.transformInfoClassesToMapStyle(this.gpFields, true)
      }
    }
  },
  methods: {
    getOffset(pos, index, offset) {
      return index === this.selectedIndex || index === this.hoverIndex
        ? pos - offset
        : pos
    },
    setMapLoaded() {
      this.isMapLoaded = true
    },
    changeSelectedStatus(index) {
      this.selectedIndex = this.selectedIndex === index ? null : index
      this.setSchoolDescription(_.isNumber(this.selectedIndex) ? this.selectedIndex : 'none')
    },
    changeHoverStatus(index) {
      this.hoverIndex = this.hoverIndex === index ? null : index
      if (!_.isNumber(this.selectedIndex)) {
        this.setSchoolDescription(_.isNumber(this.hoverIndex) ? this.hoverIndex : 'none')
      }
    },
    transformInfoClassesToMapStyle(data, notOrgs = false) {
      let missCount = 0
      this.classes = []
      this.selectedIndex = null
      this.setSchoolDescription('none')
      const organizations = data.filter((c) => c.position && !c.disabledAsSchool)
      organizations.sort(this.sortPosX)
      organizations.sort(this.sortPosY)
      const samePosOrgs = []
      for (let i = 0; i < organizations.length; i++) {
        const samePosClasses = organizations.filter(
          (p) => (p.position.split(',')[0] <= Math.round(organizations[i].position.split(',')[0]) + 1
            && p.position.split(',')[0] >= Math.round(organizations[i].position.split(',')[0]) - 1)
            && (p.position.split(',')[1] <= Math.round(organizations[i].position.split(',')[1]) + 1
              && p.position.split(',')[1] >= Math.round(organizations[i].position.split(',')[1]) - 1),
        )
        samePosOrgs.push(samePosClasses)
        missCount = samePosClasses.length - 1
        i += missCount
      }
      _.uniq(samePosOrgs)
      for (const samePosClasses of samePosOrgs) {
        const gpClass = {
          pos: samePosClasses[0].position.split(','),
          id: [],
          type: [],
          address: [],
          year: [],
          name: [],
          orgNames: [],
          orgSites: [],
          city: [],
          offset: [],
          siteUrl: []
        }
        for (let j = 0; j < samePosClasses.length; j++) {
          if (!notOrgs) {
            gpClass.year.push(samePosClasses[j].year)
            gpClass.type.push(samePosClasses[j].type)
            const orgNames = []
            const orgSites = []
            samePosClasses[j].subdivisions.forEach((subDiv) => {
              orgNames.push(subDiv.title)
              orgSites.push(subDiv.siteUrl)
            })
            if (orgNames.length <= 0) orgNames.push(samePosClasses[j].org)
            if (orgSites.length <= 0) orgSites.push(samePosClasses[j].siteUrl)
            gpClass.orgNames.push(orgNames)
            gpClass.orgSites.push(orgSites)
          }
          gpClass.id.push(notOrgs ? samePosClasses[j].id : samePosClasses[j].contentObject.id)
          gpClass.address.push(notOrgs ? samePosClasses[j].description : samePosClasses[j].address)
          gpClass.name.push(samePosClasses[j].title)
          gpClass.siteUrl.push(samePosClasses[j].siteUrl)
          gpClass.city.push(samePosClasses[j].city)
        }
        gpClass.offset = samePosClasses[0].offset
        gpClass.federalSubject = notOrgs
          ? samePosClasses[0].city
          : samePosClasses[0].federalSubject + (gpClass.type.includes('СПО') ? ' (СПО)' : '')
        this.classes.push(gpClass)
      }
    },
    sortPosX(org1, org2) {
      return (
        Number(org1.position.split(',')[0])
        - Number(org2.position.split(',')[0])
      )
    },
    sortPosY(org1, org2) {
      return (
        Number(org1.position.split(',')[1])
        - Number(org2.position.split(',')[1])
      )
    },
    setSchoolDescription(code) {
      if (code === 'none') {
        this.selectedSchool = {}
      } else {
        this.selectedSchool = this.classes[code]
      }
    }
  }
}
</script>

<style scoped>

.map-container-description {
  position: absolute;
  z-index: 1;
  right: 0;
  top: -42px;
}

.map-marker-title {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 8px;
  line-height: 9px;
  background-color: white;
  color: #2D96D4;
  padding: 1px;
  width: fit-content;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
}
.map-marker-image {
  cursor: pointer;
}
.map-svg {
  width: 1024px;
  margin-left: 70px;
  margin-right: 70px;
  margin-top: -78px;
}
.custom-skeleton {
  height: 592px;
}
</style>
